import { ObjectiveProperties } from 'apps/web/enums/pageKey';

import OBJECTIVE_FORM_KEYS from './formKeys';

const OBJECTIVE_FORM_CONTENT_MAPPER_KEYS = {
  //local and default objectives have the same keys
  localAndDefaultObjective: [
    {
      key: ObjectiveProperties.subject,
      value: OBJECTIVE_FORM_KEYS.subject,
    },
    {
      key: ObjectiveProperties.gradeLevel,
      value: OBJECTIVE_FORM_KEYS.gradeLevel,
    },
    {
      key: ObjectiveProperties.competency,
      value: OBJECTIVE_FORM_KEYS.competency,
    },
    {
      key: ObjectiveProperties.language,
      value: OBJECTIVE_FORM_KEYS.language,
    },
    {
      key: ObjectiveProperties.cognitiveVerbs,
      value: OBJECTIVE_FORM_KEYS.cognitiveVerbs,
    },
    {
      key: ObjectiveProperties.affectiveVerbs,
      value: OBJECTIVE_FORM_KEYS.affectiveVerbs,
    },
    {
      key: ObjectiveProperties.psychomotorVerbs,
      value: OBJECTIVE_FORM_KEYS.psychomotorVerbs,
    },
  ],
  americanObjective: [
    {
      key: ObjectiveProperties.curriculumFramework,
      value: OBJECTIVE_FORM_KEYS.curriculumFramework,
    },
    {
      key: ObjectiveProperties.subject,
      value: OBJECTIVE_FORM_KEYS.subject,
    },
    {
      key: ObjectiveProperties.gradeLevel,
      value: OBJECTIVE_FORM_KEYS.gradeLevel,
    },
    {
      key: ObjectiveProperties.specificStandards,
      value: OBJECTIVE_FORM_KEYS.specificStandards,
    },
    {
      key: ObjectiveProperties.objectives,
      value: OBJECTIVE_FORM_KEYS.objectives,
    },
  ],
  iplanObjective: [
    {
      key: ObjectiveProperties.subject,
      value: OBJECTIVE_FORM_KEYS.subject,
    },
    {
      key: ObjectiveProperties.gradeLevel,
      value: OBJECTIVE_FORM_KEYS.gradeLevel,
    },
    {
      key: ObjectiveProperties.competency,
      value: OBJECTIVE_FORM_KEYS.competency,
    },
    {
      key: ObjectiveProperties.language,
      value: OBJECTIVE_FORM_KEYS.language,
    },
    {
      key: ObjectiveProperties.cognitiveVerbs,
      value: OBJECTIVE_FORM_KEYS.cognitiveVerbs,
    },
    {
      key: ObjectiveProperties.psychomotorVerbs,
      value: OBJECTIVE_FORM_KEYS.psychomotorVerbs,
    },
    {
      key: ObjectiveProperties.affectiveValuesVerbs,
      value: OBJECTIVE_FORM_KEYS.affectiveValuesVerbs,
    },
    {
      key: ObjectiveProperties.affectiveValuesVerbs2,
      value: OBJECTIVE_FORM_KEYS.affectiveValuesVerbs2,
    },
    {
      key: ObjectiveProperties.affectiveValuesVerbs3,
      value: OBJECTIVE_FORM_KEYS.affectiveValuesVerbs3,
    },
    {
      key: ObjectiveProperties.affectiveAttitudesVerbs,
      value: OBJECTIVE_FORM_KEYS.affectiveAttitudesVerbs,
    },
    {
      key: ObjectiveProperties.affectiveAttitudesVerbs2,
      value: OBJECTIVE_FORM_KEYS.affectiveAttitudesVerbs2,
    },
    {
      key: ObjectiveProperties.affectiveAttitudesVerbs3,
      value: OBJECTIVE_FORM_KEYS.affectiveAttitudesVerbs3,
    },
    {
      key: ObjectiveProperties.valuesList,
      value: OBJECTIVE_FORM_KEYS.valuesList,
    },
    {
      key: ObjectiveProperties.attitudesList,
      value: OBJECTIVE_FORM_KEYS.attitudesList,
    },
    {
      key: ObjectiveProperties.valuesList2,
      value: OBJECTIVE_FORM_KEYS.valuesList2,
    },
    {
      key: ObjectiveProperties.valuesList3,
      value: OBJECTIVE_FORM_KEYS.valuesList3,
    },
    {
      key: ObjectiveProperties.attitudesList2,
      value: OBJECTIVE_FORM_KEYS.attitudesList2,
    },
    {
      key: ObjectiveProperties.attitudesList3,
      value: OBJECTIVE_FORM_KEYS.attitudesList3,
    },
  ],
};

export default OBJECTIVE_FORM_CONTENT_MAPPER_KEYS;
